import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
 add_grn_scheduler: { status: "idle" },
};

export const add_grn_scheduler_Slice = createSlice({
 name: "add_grn_scheduler",
 initialState,
 reducers: {
  success_add_grn_scheduler: (state, action) => {
   state.add_grn_scheduler = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_add_grn_scheduler: (state, action) => {
   state.add_grn_scheduler = { status: app_consts.FAIL, message: action.payload };
  },
  reset_add_grn_scheduler: (state) => {
   state.add_grn_scheduler = { status: app_consts.IDLE };
  },
  loading_add_grn_scheduler: (state) => {
   state.add_grn_scheduler = { status: app_consts.LOADING };
  },
 }
});

export const { success_add_grn_scheduler, fail_add_grn_scheduler, reset_add_grn_scheduler, loading_add_grn_scheduler } = add_grn_scheduler_Slice.actions;

export default add_grn_scheduler_Slice.reducer;